'use strict';

const Reflux = require('@muzzylane/reflux');

const SiteConfigActions = require('../actions/SiteConfigActions');

let initialized = false;
let siteConfig = null;
let siteMessage = '';
let maintenanceMode = false;
let siteFeatures = null;
let action = {};

const SiteConfigStore = Reflux.createStore({
    listenables: [SiteConfigActions],
    init: function() {},

    resetState: function() {
        siteConfig = null;
        siteMessage = '';
        maintenanceMode = false;
        siteFeatures = null;
        initialized = false;
        // action = {};
        // error = null;
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    getState: function() {
        return {
            initialized: initialized,
            siteConfig: siteConfig,
            siteMessage: siteMessage,
            maintenanceMode: maintenanceMode,
            siteFeatures: siteFeatures,
            action: action
        }
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
    },

    onGetSiteConfigCompleted: function(actionId, config) {
        initialized = true;
        siteConfig = config;
        siteMessage = config.site_message;
        action = { id: actionId };
        this.emitStatus();
    },

    onGetSiteConfigFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onUpdateSiteConfigCompleted: function(actionId, config) {
        siteConfig = config;
        siteMessage = config.site_message;
        action = { id: actionId };
        this.emitStatus();
    },

    onUpdateSiteConfigFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetSiteMessageCompleted: function(actionId, msg) {
        siteMessage = msg;
        if (siteConfig) siteConfig.site_message = msg;
        action = { id: actionId };
        this.emitStatus();
    },

    onGetSiteMessageFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetMaintenanceModeCompleted: function(actionId, modeBool) {
        action = { id: actionId };
        maintenanceMode = modeBool;
        if (siteConfig) siteConfig.maintenance_mode = modeBool;
        this.emitStatus();
    },

    onGetMaintenanceModeFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetSiteFeaturesCompleted: function(actionId, features) {
        action = { id: actionId };
        siteFeatures = features;
        this.emitStatus();
    },

    onGetSiteFeaturesFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    }
});

module.exports = SiteConfigStore;
